const integrations = {
  All: true,
  // 'Google Analytics': true,
  // AdWords: true,
  // 'Facebook Pixel': true,
  // 'Google Tag Manager': true,
};

export default integrations;
